// import { createBrowserHistory } from 'history';

// export const history = createBrowserHistory();

import { createBrowserHistory } from 'history'; // Imports from npm package

const history = createBrowserHistory();
export default history; 